import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Container,
  Row,
  Col,
  Table,
  Button,
  Modal,
  Form,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { API_BASE_URL } from "../../config";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [newUser, setNewUser] = useState({
    email: "",
    password: "",
    role: "",
    isActive: true,
    name: "",
  });

  // Fetch all users
  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/users`);
      setUsers(response.data);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewUser((prev) => ({ ...prev, [name]: value }));
  };

  // Add new user
  const addUser = async () => {
    try {
      await axios.post(`${API_BASE_URL}/api/users`, newUser);
      setShowModal(false);
      fetchUsers();
    } catch (error) {
      console.error("Error adding user:", error);
    }
  };

  // Edit existing user
  const editUser = (user) => {
    setEditingUser(user);
    setNewUser(user);
    setShowModal(true);
  };

  // Update existing user
  const updateUser = async () => {
    try {
      await axios.put(`${API_BASE_URL}/api/users/${editingUser.id}`, newUser);
      setShowModal(false);
      fetchUsers();
    } catch (error) {
      console.error("Error updating user:", error);
    }
  };

  // Delete a user
  const deleteUser = async (id) => {
    try {
      await axios.delete(`${API_BASE_URL}/api/users/${id}`);
      fetchUsers();
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      <Navbar />
      <Container className="flex-grow-1">
        <Row className="mt-4">
          <Col className="text-center">
            <Button
              onClick={() => {
                setShowModal(true);
                setNewUser({
                  email: "",
                  password: "",
                  role: "",
                  isActive: true,
                  name: "",
                });
              }}
              style={{ float: "left", marginBottom: "10px" }}
            >
              Add New Vendor
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Email</th>
                  <th>Name</th>
                  <th>Role</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user) => (
                  <tr key={user.id}>
                    <td>{user.email}</td>
                    <td>{user.name}</td>
                    <td>{user.role}</td>
                    <td>{user.isActive ? "Active" : "Inactive"}</td>
                    <td>
                      <Button variant="warning" onClick={() => editUser(user)}>
                        Edit
                      </Button>{" "}
                      <Button
                        variant="danger"
                        onClick={() => deleteUser(user.id)}
                      >
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>

        {/* Modal for Adding/Editing User */}
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>{editingUser ? "Edit User" : "Add User"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group>
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={newUser.email}
                  onChange={handleInputChange}
                />
              </Form.Group>

              <Form.Group>
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={newUser.name}
                  onChange={handleInputChange}
                />
              </Form.Group>

              <Form.Group>
                <Form.Label>Role</Form.Label>
                <Form.Control
                  as="select" // Change input type to select
                  name="role"
                  value={newUser.role} // Bind value to newUser.role
                  onChange={handleInputChange} // Handle input change
                  required // Make it required if needed
                >
                  <option value="Vendor">Select Vendor</option>
                  <option value="Vendor">Vendor</option>
                </Form.Control>
              </Form.Group>

              <Form.Group>
                <Form.Label>Status</Form.Label>
                <Form.Check
                  type="checkbox"
                  name="isActive"
                  checked={newUser.isActive}
                  onChange={(e) =>
                    setNewUser((prev) => ({
                      ...prev,
                      isActive: e.target.checked,
                    }))
                  }
                  label="Active"
                />
              </Form.Group>

              <Form.Group>
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  value={newUser.password}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Close
            </Button>
            <Button
              variant="primary"
              onClick={editingUser ? updateUser : addUser}
            >
              {editingUser ? "Update User" : "Add User"}
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
      <Footer />
    </div>
  );
};

export default UserManagement;
